import * as React from "react";
import {ChangeEvent, useRef} from "react";
import {getFileMediaType, removeItemAtIndex} from "../../../utils/Utils";
import {SetImageModel} from "../../../data/model/Producer";
import {Box, Button, HStack, Image, Input, Stack, Text, VStack} from "@chakra-ui/react";
import {CloseIcon} from "@chakra-ui/icons";
import {FileIcon, ImageIcon} from "../../atoms/SvgImage";

export const MediaSelectorComponent = ({
                                           setImages,
                                           setImageModelFunction,
                                           images,
                                           handleCloseButtonClick,
                                           description
                                       }: {
    setImages?: React.Dispatch<React.SetStateAction<SetImageModel[]>>,
    setImageModelFunction?: (model?: SetImageModel[]) => void;
    images: SetImageModel[],
    handleCloseButtonClick?: ((model: SetImageModel) => void) | undefined,
    description?: string,
}) => {
    const imageInputRef: React.RefObject<HTMLInputElement> = useRef(null);

    const handleImageButtonClick = () => {
        imageInputRef?.current?.click();
    }

    const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];

            setImages && setImages([...(images || []), {
                file,
                imageUrl: URL.createObjectURL(file),
                mediaType: getFileMediaType(file),
                name: file.name,
                isMain: false
            }]);

            setImageModelFunction && setImageModelFunction([...(images || []), {
                file,
                imageUrl: URL.createObjectURL(file),
                mediaType: getFileMediaType(file),
                isMain: false,
                name: file.name
            }])
        }
    };

    function getMediaPreviewComponent(value: SetImageModel) {
        switch (value.mediaType) {
            case "video":
                return <Box as={"video"} controls src={value.imageUrl}/>
            case "audio":
                return <Box h={"120px"} pt={"48px"} as={"audio"} controls src={value.imageUrl}/>
            case "file" || "unknown":
                return <HStack cursor={"pointer"} onClick={() => window.open(value.imageUrl, '_blank')} h={"64px"} borderRadius={"16px"} backgroundColor={"secondary"}>
                    <FileIcon strokeColor={'#006c4b'}/>
                    <Text fontSize={"16px"} fontWeight={"bold"}>{value.name ?? "test"}</Text>
                </HStack>
            default:
                return <Image cursor={"pointer"} onClick={() => window.open(value.imageUrl, '_blank')} src={value.imageUrl} alt="Uploaded Image"/>
        }
    }

    return <>
        {images?.map((value, index) => {
            return <VStack key={`image_section_${index}`}>
                {value?.imageUrl &&
                    <Stack borderRadius={"16px"} mb={"16px"} overflow={"hidden"}
                           position={"relative"} minH={"100px"} minW={"200px"} maxW={"300px"}>
                        <CloseIcon cursor={"pointer"} right={0} position={"absolute"}
                                   borderRadius={"50%"} color={"white"}
                                   p={"8px"}
                                   w={"32px"}
                                   h={"32px"}
                                   backgroundColor={"error.700"} onClick={() => {
                            handleCloseButtonClick && handleCloseButtonClick(value);
                            setImages && setImages(removeItemAtIndex(images, index));
                            setImageModelFunction && setImageModelFunction(removeItemAtIndex(images, index));
                        }}/>
                        {getMediaPreviewComponent(value)}
                    </Stack>}
            </VStack>
        })}

        <Input
            type="file"
            id="image"
            accept="*/*"
            ref={imageInputRef}
            onChange={handleImageChange}
            style={{display: 'none'}}
        />

        <Button
            colorScheme="teal"
            mt={"8px"}
            w={"100%"}
            h={"64px"}
            leftIcon={<ImageIcon w={"32px"} h={"32px"}/>}
            onClick={handleImageButtonClick}>Scegli un media</Button>

        {description && <Text fontSize={"14px"} mt={"8px"} color={"rgba(0,0,0,0.6)"}>{description}</Text>}
    </>
}
